// ABOUTME: Decide si la selfie necesita "aire" (margen arriba y a los lados) para que quepa el
// ABOUTME: peinado: si la cabeza toca el borde superior o la cara ocupa gran parte de la altura.
import { HEAD_CLASSES } from "../calibration/silhouette";

export interface Padding {
  /** Fracción de la altura original que se añade arriba. */
  top: number;
  /** Fracción del ancho original que se añade a cada lado. */
  sides: number;
}

const TOP_MARGIN_MIN = 0.12;
const HEAD_HEIGHT_MAX = 0.5;

export function headroomPadding(mask: Uint8Array, width: number, height: number): Padding | null {
  let top = -1;
  let bottom = -1;
  for (let y = 0; y < height; y++) {
    let run = 0;
    for (let x = 0; x < width; x++) {
      const c = mask[y * width + x];
      if (c === HEAD_CLASSES.hair || c === HEAD_CLASSES.faceSkin) run++;
    }
    if (run >= width * 0.03) {
      if (top < 0) top = y;
      bottom = y;
    }
  }
  if (top < 0) return null;
  const touchesTop = top / height < TOP_MARGIN_MIN;
  const tooBig = (bottom - top) / height > HEAD_HEIGHT_MAX;
  if (!touchesTop && !tooBig) return null;
  return { top: 0.35, sides: 0.15 };
}
